import React, { PropsWithChildren, useMemo } from "react";

import HorizontalNavigation, {
  HorizontalNavigationTab,
} from "../../HorizontalNavigation/HorizontalNavigation";

import { useFinOpsPermission } from "./FinOpsPermissionContext";

const FinOpsHorizontalNav: React.FC<PropsWithChildren<unknown>> = (props) => {
  const hasUpdatePermission = useFinOpsPermission();

  const tabs: HorizontalNavigationTab[] = useMemo(() => {
    const tabsForUsersWithViewPermissions = [
      {
        label: "Trade Proposals",
        path: `/Advisor/FinancialOperations/TradeProposals`,
      },
    ];
    const tabsForUsersWithUpdatePermissions = [
      {
        label: "Trade Proposal Bundles",
        path: `/Advisor/FinancialOperations/TradeProposalBundles`,
      },
      {
        label: "Staged Orders",
        path: `/Advisor/FinancialOperations/StagedOrders`,
      },
    ];
    const _unusedTabs = [
      {
        label: "Staged Trading Packs",
        path: `/Advisor/FinancialOperations/Itbs`,
      },
      {
        label: "Rendered Trading Packs",
        path: `/Advisor/FinancialOperations/ItbPacks`,
      },
      {
        label: "Rebalances",
        path: `/Advisor/FinancialOperations/Rebalances`,
      },
    ];
    return hasUpdatePermission
      ? [
          ...tabsForUsersWithViewPermissions,
          ...tabsForUsersWithUpdatePermissions,
        ]
      : [...tabsForUsersWithViewPermissions];
  }, [hasUpdatePermission]);

  return (
    <HorizontalNavigation tabs={tabs}>{props.children}</HorizontalNavigation>
  );
};

export default FinOpsHorizontalNav;
